/* @flow */
import {trigger as edapTrigger} from './edapWrapper';

export const GIFTCARD_SUBMIT_SUCCESS = 'giftcard.submit.success';
export const GIFTCARD_SUBMIT_FAILURE = 'giftcard.submit.failure';
export const GIFTCARD_PHOTO_COMPRESS_FAILURE = 'giftcard.photo.compress.failure';

type EdapEventAction =
    | typeof GIFTCARD_SUBMIT_FAILURE
    | typeof GIFTCARD_SUBMIT_SUCCESS
    | typeof GIFTCARD_PHOTO_COMPRESS_FAILURE ;

type GiftCardInformationShape = {
    certificateNumber: String,
    id: number,
    orderId: String
}

export type GiftCardDataShape = {
    firstName: string,
    lastName: string,
    email: string,
    phone: {
        phoneNumber: string,
        countryCode: string
    },
    giftCardInformation: [GiftCardInformationShape]
};

const triggerGCSubmitEdapEvent = (
    eventData?: GiftCardDataShape | string,
    eventCategory: EdapEventAction,
    delayProcessing?: boolean
) => {
    const options = {delayProcessing};

    let data = {
        giftCardData: eventData
    };

    edapTrigger(eventCategory, data, options);
};

export const triggerGiftCardSubmitSuccessEvent = (
    eventData: GiftCardDataShape
) => {
    triggerGCSubmitEdapEvent(eventData, GIFTCARD_SUBMIT_SUCCESS, false);
};

export const triggerGiftCardSubmitFailureEvent = (
    eventData: GiftCardDataShape
) => {
    triggerGCSubmitEdapEvent(eventData, GIFTCARD_SUBMIT_FAILURE, false);
};

export const triggerGiftCardPhotoCompressFailureEvent = (
    eventData: string // TODO: update shape
) => {
    triggerGCSubmitEdapEvent(eventData, GIFTCARD_PHOTO_COMPRESS_FAILURE, false);
};
